import React, { Component } from 'react';
import ReactGA from 'react-ga';

class Analytics extends Component {
    componentDidMount() {
        ReactGA.pageview(window.location.hash);
    }

    render(){
        return null
    }

}

export default Analytics



// WEBPACK FOOTER //
// ./src/components/Analytics.js